import { connect } from 'react-redux';
import { setShareState } from 'core/slices/shareState';
import Share from '../../../components/visualizer/Share';

export default connect(state => ({}), { setShareState })(Share);
